<template>
  <pf-grid gutter v-if="wizard.askRegion">
    <wizard-summary-location />
  </pf-grid>

  <pf-grid gutter v-if="wizard.askProdotti">
    <wizard-summary-option
      v-if="wizard.askOs && !wizard.askEssentialOs && !wizard.askCockpitConfig"
      :name="$t('Sistema operativo')"
      :value="wizard.os"
      edit-step="WizardStepProdottiInfrastruttura"
      ouia-id="wizard-summary-infrastruttura-os"
    />

    <wizard-summary-option
      :name="wizard.path === 'cloud' ? $t('Risorse') : $t('Prodotto')"
      edit-step="WizardStepProdottiInfrastruttura"
      ouia-id="wizard-summary-infrastruttura-prodotto"
    >
      <template v-if="wizard.path === 'cloud'">
        {{ wizard.cpuCloudQt }} <cpu-icon title="cpu" /> {{ wizard.ramCloudQt }} GB <memory-icon title="ram" /> {{ wizard.storageCloudQt }} GB
        <volume-icon title="storage" />
      </template>
      <strong v-else>
        {{ wizard.sceltaProdottoInfrastruttura }}
      </strong>
    </wizard-summary-option>

    <wizard-summary-option
      v-if="wizard.askNomeServer"
      :name="$t('Nome')"
      :value="wizard.nomeServer"
      edit-step="WizardStepProdottiInfrastruttura"
      ouia-id="wizard-summary-infrastruttura-nome"
    />

    <wizard-summary-host-addon v-if="wizard.path === 'host'" />

    <wizard-summary-option v-if="wizard.askStack" :name="$t('Stack')" edit-step="WizardStepStack" ouia-id="wizard-summary-infrastruttura-stack">
      <strong>
        {{ wizard.stack ?? $t('Nessuno') }}
        <template v-if="wizard.askEssentialOs">({{ wizard.essentialOs === 'altro' ? wizard.essentialOtherOs : wizard.essentialOs }})</template>
        <template v-else-if="wizard.askCockpitConfig">({{ wizard.cockpitOs }} - {{ wizard.cockpitWs }})</template>
      </strong>
    </wizard-summary-option>

    <wizard-summary-option
      v-if="wizard.configurazione"
      :name="$t('Configurazione')"
      edit-step="WizardStepConfigurazione"
      ouia-id="wizard-summary-infrastruttura-tecnologie"
    >
      <strong>{{ $t('Personalizzata') }}</strong>
      {{ ' ' }}
      <form-help-tooltip :text="wizard.configurazione" />
    </wizard-summary-option>

    <wizard-summary-licenze-win v-if="wizard.askAddonWindows" />
    <wizard-summary-addon-cpanel v-else-if="wizard.askAddonCpanel" />
  </pf-grid>

  <pf-grid gutter v-if="wizard.askAddonStorage || wizard.askAddonSla">
    <wizard-summary-option
      v-if="wizard.askAddonStorage"
      :name="$t('Storage aggiuntivo')"
      edit-step="WizardStepProdottiInfrastruttura"
      ouia-id="wizard-summary-storage"
    >
      <strong v-if="wizard.codiceStorageCloud">
        {{ wizard.getProdotto(wizard.codiceStorageCloud).nome }} - {{ $t('{0} TB', [wizard.qtAddonStorage]) }}
      </strong>
      <strong v-else>{{ $t('No') }}</strong>
    </wizard-summary-option>

    <wizard-summary-option
      v-if="wizard.askAddonSla"
      :name="$t('Assistenza Premium')"
      :value="wizard.addonSla ? $t('Richiesta') : $t('Non richiesta')"
      edit-step="WizardStepAddon"
      ouia-id="wizard-summary-addon-sla"
    />
  </pf-grid>

  <pf-grid gutter v-if="wizard.askMailAddon">
    <wizard-summary-option
      v-if="!wizard.mailAddon"
      :name="$t('Servizio mail')"
      :value="$t('Non richiesto')"
      edit-step="WizardStepAddon"
      ouia-id="wizard-summary-mail-attivazione"
    />

    <wizard-summary-option
      v-else-if="wizard.codiceProdottoMail"
      :name="$t('Prodotto mail')"
      :value="wizard.codiceProdottoMail"
      edit-step="WizardStepAddon"
      ouia-id="wizard-summary-mail-prodotto"
    />
  </pf-grid>
</template>

<script lang="ts" setup>
import { $t as _t } from '@/i18n';
import WizardSummaryOption from './wizard-summary-option.vue';
import WizardSummaryLocation from './wizard-summary-location.vue';
import WizardSummaryHostAddon from './wizard-summary-host-addon.vue';
import WizardSummaryLicenzeWin from './wizard-summary-licenze-win.vue';
import WizardSummaryAddonCpanel from './wizard-summary-addon-cpanel.vue';
import CpuIcon from '@vue-patternfly/icons/cpu-icon';
import MemoryIcon from '@vue-patternfly/icons/memory-icon';
import VolumeIcon from '@vue-patternfly/icons/volume-icon';
import FormHelpTooltip from '@/components/FormHelpTooltip.vue';
import { useWizard } from '@/wizard';

const wizard = useWizard();
</script>
